// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  TGetEstimationRealtorFormRequest,
  TGetEstimationRealtorFormModel,
  IMappers,
  TGetEstimationRealtorFormResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetEstimationRealtorFormResponse } from '../../entities/estimation/GetEstimationRealtorFormResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetEstimationRealtorFormModel(
  parameters: TGetEstimationRealtorFormRequest,
): TGetEstimationRealtorFormModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/get-estimation-realtor-form/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetEstimationRealtorFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetEstimationRealtorFormRequest;
}

export async function fetchGetEstimationRealtorForm<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationRealtorFormOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetEstimationRealtorFormResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetEstimationRealtorFormModel(parameters),
    config,
  )) as FetchResponse<TGetEstimationRealtorFormResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationRealtorFormResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetEstimationRealtorFormResponse>;
}
